export default "__VITE_ASSET__5ab17978__"